import { Figure, PlotParams } from "react-plotly.js";
import { Camera, ColorBar } from "plotly.js";

const DATA_PATH = process.env.REACT_APP_DATA_PATH;

export const OTHER_DATASET_NAME = "Local CSV File";

export const ID_COLUMN = "subjectID";

export const Datasets = [
  {
    name: "Dataset 1 (n=14k)",
    source: DATA_PATH + "/dummydata1.dc2263a7f4.csv",
  },
  {
    name: "Dataset 2 (n=650)",
    source: DATA_PATH + "/dummydata2.4dac7ba2ad.csv",
  },
  {
    name: OTHER_DATASET_NAME,
  },
];

export const METHOD_COLUMN_PREFIX = "Rep_";
export const METHOD_COLUMN_SUFFIX_X = "_X";
export const METHOD_COLUMN_SUFFIX_Y = "_Y";
export const METHOD_COLUMN_SUFFIX_Z = "_Z";
export const METHOD_COLUMN_REGEX = /^Rep_/;
export const META_COLUMN_PREFIX = "Meta_";
export const META_COLUMN_REGEX = /^Meta_/;
export const PREDICTION_COLUMN_PREFIX = "Pred_";
export const PREDICTION_COLUMN_REGEX = /^Pred_/;
export const CON_SCORE_COLUMN_PREFIX = "CON_";

export const PLOT_LAYOUT: Figure["layout"] = {
  autosize: true,
  margin: {
    l: 0,
    r: 0,
    b: 0,
    t: 25,
  },
  legend: {
    x: 1,
    y: 1,
    traceorder: "normal" as const,
    xanchor: "auto" as const,
  },
  scene: {
    xaxis: {
      visible: true,
      showline: false,
      // color: "red",
      color: "black",
      linewidth: 3,
      // showaxeslabels: true,
      showgrid: false,
      zeroline: false,
      // zerolinewidth: 3,
      // rangemode: "tozero",
    },
    yaxis: {
      visible: false,
      showline: false,
      // color: "green",
      color: "black",
      // showaxeslabels: true,
      showgrid: false,
      // showdividers: false,
      zeroline: false,
      // rangemode: "tozero",
    },
    zaxis: {
      visible: false,
      showline: true,
      // color: "blue",
      color: "black",
      // showaxeslabels: true,
      showgrid: false,
      // showdividers: false,
      zeroline: false,
      // rangemode: "tozero",
    },
  },
};

const CAMERA = {
  center: {
    x: 0,
    y: 0,
    z: 0,
  },
};

export const CAMERA_XZ = {
  ...CAMERA,
  eye: {
    x: 0.1,
    y: 2.5,
    z: 0.1,
  },
  up: {
    x: 0,
    y: 1,
    z: 0,
  },
};

export const CAMERA_YZ = {
  ...CAMERA,
  eye: {
    x: 2.5,
    y: 0.1,
    z: 0.1,
  },
  up: {
    x: 0,
    y: 0,
    z: 1,
  },
};

export const CAMERA_XY = {
  ...CAMERA,
  eye: {
    x: 0.1,
    y: 0.1,
    z: 2.5,
  },
  up: {
    x: 0,
    y: 1,
    z: 0,
  },
};

export const COLOR_BAR: Partial<ColorBar> = {
  thickness: 10,
  len: 0.5,
  x: 0.9,
  y: 0.5,
};

export const TRACE_CONFIG = {
  hoverinfo: "all" as const,
  mode: "markers" as const,
  type: "scatter3d" as const,
  marker: {
    size: 5,
    symbol: "circle" as const,
    line: {
      color: "rgba(217, 217, 217, 1)",
      dash: "dash" as const,
      width: 1,
    },
    opacity: 1,
  },
};

export const MARKER_STYLE_INITIAL = {
  opacity: TRACE_CONFIG.marker.opacity,
  size: TRACE_CONFIG.marker.size,
  line: { ...TRACE_CONFIG.marker.line },
};

export const HISTOGRAM_LAYOUT: Figure["layout"] = {
  width: 800,
  height: 200,
  paper_bgcolor: "transparent",
  plot_bgcolor: "transparent",
  showlegend: false,
  dragmode: false,
};

export const PLOT_CONFIG: PlotParams["config"] = {
  displayModeBar: true,
};

export const HISTOGRAM_CONFIG = {
  displayModeBar: false,
};

export const LINK_TO_DOCS = "/docs.html";
